/**
 * AITutorFab — nút nổi góc phải dưới + Drawer AI Tutor, dùng chung cho trang bài
 * học và trang môn học (2026-10-03).
 *
 * Phiên chat gắn theo `lessonSlug` (RAG giới hạn trong môn của bài đó — xem
 * `apps.learning.services.rag.engine`). Trang môn học truyền bài đầu tiên của môn
 * → chat trong phạm vi nội dung môn. Panel tự quản lý phiên (mở phiên gần nhất,
 * phiên mới chỉ tạo conversation khi gửi câu đầu tiên — 2026-10-04).
 */
import { useState } from "react";
import { FloatButton } from "antd";
import { RobotOutlined } from "@ant-design/icons";

import { AITutorPanel } from "./AITutorPanel";

interface Props {
  lessonSlug: string | undefined;
  /** Hiện ở header Drawer (tên bài / tên môn). */
  title?: string;
  tooltip?: string;
}

export function AITutorFab({ lessonSlug, title, tooltip = "Hỏi AI Tutor" }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <FloatButton
        icon={<RobotOutlined />}
        type="primary"
        tooltip={tooltip}
        onClick={() => lessonSlug && setOpen(true)}
        style={{ right: 24, bottom: 24, background: "#722ed1" }}
        data-testid="ai-tutor-fab"
      />
      {/* `key`: sang bài khác → panel mới (phiên đang chọn thuộc bài cũ). */}
      <AITutorPanel
        key={lessonSlug ?? ""}
        open={open}
        onClose={() => setOpen(false)}
        lessonSlug={lessonSlug}
        lessonTitle={title}
      />
    </>
  );
}
